import type { DependencyList, MutableRefObject } from "react";
import { useEffect, useRef, useState } from "react";

/**
 * @param deps - When provided, re-runs intersection observation when deps change.
 *   Use this when layout (e.g. scrollable content) changes so visibility is re-evaluated.
 */
export const useIsVisibleOnDOM = <T extends HTMLElement>(
  deps: DependencyList = [],
): [MutableRefObject<T | null>, boolean] => {
  const ref = useRef<T>(null);
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const observer = new IntersectionObserver(e => {
      setIsVisible(e?.[0].isIntersecting);
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- The deps will be dynamic
  }, deps);

  return [ref, isVisible];
};
